import { ISwipeStep } from '../types/steps';

export const backgroundQuestionsSteps: ISwipeStep[] = [
    {
        name: 'subtitles',
        text: `Je zit op 3 meter afstand van de tv of presentatie op je werk.
        <strong>Kun je de tekst nog goed lezen?</strong>`,
        reverseAnswer: true,
    },
    {
        name: 'television',
        text: `Kijk je meer dan 2 uur per dag op een computer, tablet,
        telefoon of tv?`,
        reverseAnswer: false,
    },
    {
        name: 'roadSigns',
        text: `Je rijdt in de auto. Kun je nog makkelijk <strong>
        de tekst van verkeersborden lezen?</strong>`,
        reverseAnswer: true,
    },
    {
        name: 'smoking',
        text: 'Heb je in de afgelopen 15 jaar <strong>gerookt?</strong>',
        subText: '(een pakje of meer per dag)',
        reverseAnswer: false,
    },
    {
        name: 'burningEyes',
        text: `Heb je wel eens last van <strong>branderige of waterige ogen?
        </strong>`,
        reverseAnswer: false,
    },
    {
        name: 'flashes',
        text: 'Zie je wel eens <strong>flitsen of zwevende deeltjes?</strong>',
        reverseAnswer: false,
    },
    {
        name: 'headaches',
        text: 'Heb je regelmatig last van <strong>hoofdpijn?</strong>',
        reverseAnswer: false,
    },
    {
        name: 'diabetes',
        text: 'Heb je <strong>diabetes?</strong>',
        reverseAnswer: false,
    },
    {
        name: 'walkOutside',
        text:
            'Maak je weleens een <strong>ommetje buiten</strong>, minimaal 3x per week?',
        reverseAnswer: true,
    },
];
